import React, { PureComponent } from 'react'
import './messageList.less'
import { DatePicker, Table, Icon, Popover, Button } from 'antd';
import moment from 'moment';
import API from '../../../api/api';
import EMOJI from '../../../assets/js/emoji'
import DialogBox from '../dialogBox/dialogBox'

const { RangePicker } = DatePicker;

class messageListComponent extends PureComponent {

    constructor(props) {
        super(props)
        this.onDatePickerChange = this.onDatePickerChange.bind(this)
        this.onPaginationChange = this.onPaginationChange.bind(this)
        this.onShowSizeChange = this.onShowSizeChange.bind(this)
        this.onRangePickerOk = this.onRangePickerOk.bind(this)
        this.modelClose = this.modelClose.bind(this)
        this.operation = this.operation.bind(this);
        this.columns = [
            {
                title: '留言人',
                dataIndex: 'fromNickName',
                key: 'fromNickName',
                render: (text, record) => (
                    <Popover placement="right" content={
                        <div className="popover-content">
                            <div className="popover-image"
                                style={{
                                    backgroundImage: `url(${(record && record.fromUserImage && record.fromUserImage !== null &&
                                        record.fromUserImage.indexOf("s1.im-dangdang.com") !== -1) ?
                                        JSON.parse(record.fromUserImage).picture : ""})`
                                }}>
                            </div>
                            <div className="popover-name">
                                <span>{record.fromNickName}</span>
                                {
                                    record.fromSex ? <Icon type="man" /> : <Icon type="woman" />
                                }
                            </div>
                            <div className="personalSignature">{record.fromSignature}</div>
                            <div className="region">
                                <span>地区</span>
                                <span>{record.fromUserArea}</span>
                            </div>
                        </div>
                    }>
                        <Button type="link" className="nickName">
                            <span
                                className="userImage"
                                style={{
                                    backgroundImage: `url(${(record && record.fromUserImage && record.fromUserImage !== null &&
                                        record.fromUserImage.indexOf("s1.im-dangdang.com") !== -1) ?
                                        JSON.parse(record.fromUserImage).picture : ""})`
                                }}>
                            </span>
                            {text}
                        </Button>
                    </Popover>
                ),
                className: 'word-wrap',
                // width: '100px'
            },
            {
                title: '马甲号',
                dataIndex: 'toNickName',
                key: 'toNickName',
                className: 'word-wrap',
                render: (text, record) => (
                    <div className="nickName">
                        <span
                            className="userImage"
                            style={{
                                backgroundImage: `url(${(record && record.toUserImage && record.toUserImage !== null &&
                                    record.toUserImage.indexOf("s1.im-dangdang.com") !== -1) ?
                                    JSON.parse(record.toUserImage).picture : ""})`
                            }}>
                        </span>
                        {text}
                    </div>
                )
            },
            {
                title: '马甲铛铛号',
                dataIndex: 'toUserDdAccount',
                key: 'toUserDdAccount',
                className: 'word-wrap'
            },
            {
                title: '留言内容',
                dataIndex: 'msg',
                key: 'msg',
                render: (text, record) => (
                    <span>
                        <pre className="msg" dangerouslySetInnerHTML={{ __html: EMOJI.Word2Emoji(text) }}></pre>
                    </span>
                ),
                className: 'word-wrap'
            },
            {
                title: '时间',
                dataIndex: 'createTime',
                key: 'createTime',
                render: (text, record) => (
                    <span>
                        {moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')}
                    </span>
                ),
                className: 'word-wrap'
            },
            {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                render: (text, record) => (
                    <span>
                        <Button onClick={() => this.operation(record)} type="link">回复</Button>
                    </span>
                ),
                className: 'word-wrap'
            },
        ]
    }

    state = {
        key: void 0, // 1 广场 2 资讯 3 附近的人 4 红包天天乐 5 添加朋友 6 朋友消息
        dataSource: [],
        pagination: {
            hideOnSinglePage: true,
            showQuickJumper: true,
            showSizeChanger: true,
            onShowSizeChange: this.onShowSizeChange,
            pageSize: 10,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
            onChange: this.onPaginationChange
        },
        loading: false,
        modalVisible: false,
        modelData: void 0,
        startTime: null,
        endTime: null,
        valueRangePicker: [moment().startOf('day'), moment().endOf('day')]
    };

    componentWillReceiveProps(nextProps) {
        console.log('messageList,',this.state.key,nextProps)
        if (this.state.key !== nextProps.match.params.key) {
            const pagination = { ...this.state.pagination };
            pagination.current = 1;
            pagination.pageSize = 10;
            this.setState({
                key: nextProps.match.params.key,
                startTime: null,
                endTime: null,
                valueRangePicker: [moment().startOf('day'), moment().endOf('day')],
                pagination
            }, () => {
                this.getList({
                    msgType: this.props.match.params.key,
                    curPageNo: 1,
                    pageCount: 10
                });
            })
        }
    }
    
    componentDidMount() {
        this.setState({ key: this.props.match.params.key })
        //进入获取数据，默认当天
        this.getList({
            msgType: this.props.match.params.key,
            curPageNo: 1,
            pageCount: 10
        });
    }

    async getList(params) {
        this.setState({ loading: true });
        let result = await API.msgList(params);
        if (!result) return;
        if (result.status === "1") {
            const pagination = { ...this.state.pagination };
            pagination.total = result.data.totalCount;
            this.setState({
                loading: false,
                dataSource: result.data.msgList,
                pagination,
                modelData: result.data.msgList[0]
            });
        }
        if (result.status === "14014") {
            this.props.history.replace('/welcomePage')
        }
    };

    handleTableChange = (pagination, filters, sorter) => {
        // const pager = { ...this.state.pagination };
        // pager.current = pagination.current;
        // pager.pageSize = pagination.pageSize;
        this.setState({ pagination });
        const { startTime, endTime } = this.state;
        this.getList({
            msgType: this.state.key,
            curPageNo: pagination.current,
            pageCount: pagination.pageSize,
            startTime,
            endTime,
        });
    };

    onDatePickerChange(dates) {
        this.setState({
            startTime: dates.length > 0 ? dates[0].unix() : null,
            endTime: dates.length > 0 ? dates[1].unix() : null,
            valueRangePicker: dates.length > 0 ? [dates[0], dates[1]] : null
        })
        // this.getList({
        //     msgType: this.state.key,
        //     curPageNo: 1,
        //     pageCount: this.state.pagination.pageSize
        // });
    }

    onRangePickerOk() {
        const { startTime, endTime, valueRangePicker } = this.state;
        let s = startTime, e = endTime;

        if (startTime == null) {
            if (valueRangePicker == null) {
                s = null
            } else {
                s = moment().startOf('day').unix()
            }
        }
        if (endTime == null) {
            if (valueRangePicker == null) {
                e = null
            } else {
                e = moment().endOf('day').unix()
            }
        }
        this.getList({
            msgType: this.state.key,
            curPageNo: 1,
            pageCount: this.state.pagination.pageSize,
            startTime: s,
            endTime: e,
        });
    }

    onPaginationChange(pageCountber) {
    }

    onShowSizeChange(current, pageSize) {
    }

    /**
     * 点击回复唤起弹框，并传值
     * @param {*} item 点击的cell 
     */
    operation(item) {
        this.setState({ modalVisible: true, modelData: item })
    }
    modelClose() {
        this.setState({ modalVisible: false })
    }
    render() {
        const { dataSource, pagination, loading, modalVisible, modelData, valueRangePicker, key } = this.state;
        return (
            <div className="message-list">
                <RangePicker
                    ranges={{
                        '当天': [moment().startOf('day'), moment().endOf('day')],
                        '当月': [moment().startOf('month'), moment().endOf('month')],
                        '本年': [moment().startOf('year'), moment().endOf('year')],
                    }}
                    format="YYYY/MM/DD HH:mm:ss"
                    value={valueRangePicker}
                    size={'large'}
                    onChange={this.onDatePickerChange}
                    // onOk={this.onRangePickerOk}
                    renderExtraFooter={() => '(快捷选择)'}
                    // showTime
                    style={{ width: '480px' }}
                />
                <Button size="large" type="primary" icon="search" className="searchBtn" onClick={this.onRangePickerOk}>
                    筛选
                </Button>
                <Table
                    rowKey={(record, index) => index}
                    dataSource={dataSource}
                    pagination={pagination}
                    columns={key === '6' ? this.columns.slice(0, this.columns.length - 1) : this.columns} //朋友消息不可回复
                    loading={loading}
                    onChange={this.handleTableChange}
                    // scroll={{ x: true,y: 450 }}
                    onRow={(record, index) => {
                        return {
                            onClick: event => { }, // 点击行
                            onDoubleClick: event => { },
                            onContextMenu: event => { },
                            onMouseEnter: event => { }, // 鼠标移入行
                            onMouseLeave: event => { },
                        };
                    }}
                    onCell={(record, rowIndex) => {
                        return {
                            onClick: event => { }, // 点击行
                            onDoubleClick: event => { },
                            onContextMenu: event => { },
                            onMouseEnter: event => { }, // 鼠标移入行
                            onMouseLeave: event => { },
                        };
                    }}
                    style={{ marginTop: '24px' }}
                />
                
                <DialogBox visible={modalVisible} msgType={key} modelData={modelData} modelClose={this.modelClose} />
            </div>
        );
    }
}

export default messageListComponent